#import "../../../shared/graphql/fragments/sales-document-fragment.graphql"

query GetInvoiceById($id: ID!) {
    invoice(id: $id) {
        ...SalesDocumentFragment
    }
}
